// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3395":"7e7061781534e9f8","8960":"be282bd3e33c20e3"}[chunkId] + ".css";
};